define('dcf-popup',["exports", "./dcf-utility", "./dcf-button-toggle"], function (_exports, _dcfUtility, _dcfButtonToggle) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DCFPopupTheme = _exports.DCFPopup = void 0;

  function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

  var DCFPopupTheme = /*#__PURE__*/function () {
    // Sets up the theme
    function DCFPopupTheme() {
      _classCallCheck(this, DCFPopupTheme);

      this.popupClassList = ['dcf-relative'];
      this.popupButtonClassList = [];
      this.popupContentClassList = ['dcf-absolute', 'dcf-z-modal-fullscreen']; // This is for when we our mouse leaves and comes back
      // This is helpful for the point option for the popup

      this.hoverTimeoutDuration = 250;
    } // Allows us to set the theme variables if they are defined and we match the types


    _createClass(DCFPopupTheme, [{
      key: "setThemeVariable",
      value: function setThemeVariable(themeVariableName, value) {
        if (themeVariableName in this && _typeof(value) == _typeof(this[themeVariableName])) {
          this[themeVariableName] = value;
        }
      }
    }]);

    return DCFPopupTheme;
  }();

  _exports.DCFPopupTheme = DCFPopupTheme;

  var DCFPopup = /*#__PURE__*/function () {
    // Set up the button
    function DCFPopup(popups, theme) {
      _classCallCheck(this, DCFPopup);

      if (theme instanceof DCFPopupTheme) {
        this.theme = theme;
      } else {
        this.theme = new DCFPopupTheme();
      } // Event intended for closing any open popups


      this.popupOpenEvent = new Event(DCFPopup.events('popupOpen')); // Events for controlling toggle button

      this.commandOpen = new Event(_dcfButtonToggle.DCFToggleButton.events('commandOpen'));
      this.commandClose = new Event(_dcfButtonToggle.DCFToggleButton.events('commandClose'));
      this.commandToggle = new Event(_dcfButtonToggle.DCFToggleButton.events('commandToggle'));
      this.positions = ['top', 'bottom', 'left', 'right'];
      this.alignments = ['start', 'center', 'end']; // Create a random ID for the button

      this.uuid = _dcfUtility.DCFUtility.uuidv4(); // Store the button inputted (always will be an array )

      this.popups = popups;

      if (NodeList.prototype.isPrototypeOf(this.popups)) {
        this.popups = Array.from(this.popups);
      } else if (!Array.isArray(this.popups)) {
        this.popups = [this.popups];
      }
    } // The names of the events to be used easily


    _createClass(DCFPopup, [{
      key: "initialize",
      value: // Initialize the popup that were inputted in the constructor
      function initialize() {
        var _this = this;

        // Loops through each one
        this.popups.forEach(function (popup, index) {
          // Adds any classes from the theme to the popup
          if (_this.theme.popupClassList) {
            _this.theme.popupClassList.forEach(function (cssClass) {
              popup.classList.add(cssClass);
            });
          } // Gets the button and validates it


          var popupBtn = popup.querySelector('.dcf-btn-popup');

          if (popupBtn === null || popupBtn.tagName !== 'BUTTON') {
            throw new Error('Popup Button Is Missing Or Not A Button Tag');
          } // Gets the content and validates it


          var popupContent = popup.querySelector('.dcf-popup-content');

          if (popupContent === null) {
            throw new Error('Popup Content Is Missing');
          }

          var closeButton = popup.querySelector('.dcf-btn-popup-close');

          if (closeButton !== null && closeButton.tagName !== 'BUTTON') {
            throw new Error('Close Button is Not a Button Tag');
          } // Sets the IDs for the btn and content if they aren't already set


          if (popup.id === '') {
            popup.id = _this.uuid.concat("-popup-".concat(index));
          }

          if (popupBtn.id === '') {
            popupBtn.id = _this.uuid.concat("-popup-btn-".concat(index));
          }

          if (popupContent.id === '') {
            popupContent.id = _this.uuid.concat("-popup-content-".concat(index));
          } // Adds any classes to the theme


          if (_this.theme.popupButtonClassList) {
            _this.theme.popupButtonClassList.forEach(function (cssClass) {
              popupBtn.classList.add(cssClass);
            });
          }

          if (_this.theme.popupContentClassList) {
            _this.theme.popupContentClassList.forEach(function (cssClass) {
              popupContent.classList.add(cssClass);
            });
          } // Sets up button-toggle related attributes


          popupBtn.dataset.controls = popupContent.id;
          popupBtn.dataset.startExpanded = 'false'; // Sets up position classes

          _this.addPositionClasses(popup, popupContent); // Initializes the toggle button


          var toggleButtonObj = new _dcfButtonToggle.DCFToggleButton(popupBtn);
          toggleButtonObj.initialize(); // if there is a close button and its clicked close the popup

          if (closeButton !== null) {
            closeButton.addEventListener('click', function () {
              popupBtn.dispatchEvent(_this.commandClose);
            });
          } // When a popup is toggled open it will dispatch an event


          popupContent.addEventListener(_dcfButtonToggle.DCFToggleButton.events('toggleElementOn'), function () {
            popup.dispatchEvent(_this.popupOpenEvent);
          }); // If any popup on the document opens and it doesn't match we will close

          document.addEventListener(DCFPopup.events('popupOpen'), function (e) {
            if (e.target.id !== popup.id) {
              popupBtn.dispatchEvent(_this.commandClose);
            }
          }, true); // If we click outside the popup close the popup
          // Event listener is on body since we want to check if we click anywhere but element

          document.body.addEventListener('click', function (event) {
            // We then check if where we clicked has any ancestor element that is out popup
            var closestPopup = event.target.closest('.dcf-popup');

            if (closestPopup === null || closestPopup.id !== popup.id) {
              // If the ids match we can use the secret toggle button to close the popup
              popupBtn.dispatchEvent(_this.commandClose);
            }
          }, true); // if the popup has a data attribute hover it will set up the hover event listeners

          if (popup.dataset.hover === 'true') {
            // Set up the mouse leave event listener
            // (This will not fire when moving from one child to the next)
            popup.addEventListener('mouseleave', function () {
              // If there is a point it will have a gap so we want to make sure they are definitely gone
              // If they enter again it will cancel out this timeout
              // Stores the timeout value in the data attribute on the element since it is element specific
              popup.dataset.hoverTimeout = setTimeout(function () {
                popup.removeAttribute('data-hover-timeout'); // This button is a toggle button secretly so we can control it via its event listeners

                popupBtn.dispatchEvent(_this.commandClose);
              }, _this.theme.hoverTimeoutDuration);
            }); // Sets up the mouse enter event listener
            // this is more normal than the leave one

            popup.addEventListener('mouseenter', function () {
              // If we come back before the timeout is over then we can cancel it and remove it
              clearTimeout(popup.dataset.hoverTimeout);
              popup.removeAttribute('data-hover-timeout'); // This button is a toggle button secretly so we can control it via its event listeners

              popupBtn.dispatchEvent(_this.commandOpen);
            });
          }
        });
      }
      /**
       * Sets up the DCF classes for the popup content based on the popup data attributes
       * @param {HTMLDivElement} popup Popup Div
       * @param {HTMLDivElement} popupContent Popups content Div
       */

    }, {
      key: "addPositionClasses",
      value: function addPositionClasses(popup, popupContent) {
        // Gets the position data attribute and checks it
        var position = popup.dataset.position;

        if (position === undefined) {
          position = 'bottom'; // Set default value
        } else if (!this.positions.includes(position)) {
          throw new Error('Invalid Position On Popup'); // error is if it is invalid
        } // Gets the alignment data attribute and checks it


        var alignment = popup.dataset.alignment;

        if (alignment === undefined) {
          alignment = 'center'; // Sets default value
        } else if (!this.alignments.includes(alignment)) {
          throw new Error('Invalid Alignment On Popup'); // Error if it is not set
        } // Set up position specific classes


        if (position === 'top') {
          popupContent.classList.add('dcf-bottom-100%');
        } else if (position === 'bottom') {
          popupContent.classList.add('dcf-top-100%');
        } else if (position === 'left') {
          popupContent.classList.add('dcf-right-100%');
        } else if (position === 'right') {
          popupContent.classList.add('dcf-left-100%');
        } // Set up alignment classes


        if (position === 'top' || position === 'bottom') {
          if (alignment === 'start') {
            popupContent.classList.add('dcf-left-0');
          } else if (alignment === 'end') {
            popupContent.classList.add('dcf-right-0');
          } else if (alignment === 'center') {
            popupContent.classList.add('dcf-left-50%');
          }
        } else if (position === 'left' || position === 'right') {
          if (alignment === 'start') {
            popupContent.classList.add('dcf-top-0');
          } else if (alignment === 'end') {
            popupContent.classList.add('dcf-bottom-0');
          } else if (alignment === 'center') {
            popupContent.classList.add('dcf-top-50%');
          }
        }
      }
    }], [{
      key: "events",
      value: function events(name) {
        // Define any new events
        var events = {
          popupOpen: 'popupOpen'
        };
        Object.freeze(events); // Forward the events from the DCFToggleButton

        if (_dcfButtonToggle.DCFToggleButton.events(name) !== undefined) {
          return _dcfButtonToggle.DCFToggleButton.events(name);
        } // Return the name of the event if it exists if not it will return undefined


        return name in events ? events[name] : undefined;
      }
    }]);

    return DCFPopup;
  }();

  _exports.DCFPopup = DCFPopup;
});

